package com.eladfinish.bible.contest.screens.misc

import kotlinx.collections.immutable.persistentListOf

internal val miscLinkItems by lazy {
    persistentListOf(
        MiscLinkItem(
            text = "זוכי החידונים לאורך השנים",
            link = "https://archive.jewishagency.org/he/bible-quiz/program/30871/",
        ),
        MiscLinkItem(
            text = """חידון התנ"ך בוויקיפדיה""",
            link = "https://he.wikipedia.org/wiki/%D7%97%D7%99%D7%93%D7%95%D7%9F_%D7%94%D7%AA%D7%A0%22%D7%9A_%D7%94%D7%A2%D7%95%D7%9C%D7%9E%D7%99_%D7%9C%D7%A0%D7%95%D7%A2%D7%A8_%D7%99%D7%94%D7%95%D7%93%D7%99"
        ),
        MiscLinkItem(
            text = """חידון התנ"ך באתר משרד החינוך""",
            link = "http://edu.gov.il/noar/BibleContest/Pages/home-page.aspx",
        ),
        MiscLinkItem(
            text = """ארגז הכלים שלכם להצלחה""",
            link = "https://meyda.education.gov.il/files/noar/toolbox_feb_2017.pdf",
        ),
        MiscLinkItem(
            text = """חוברת טיפים - חננאל מלכה""",
            link = "https://meyda.education.gov.il/files/noar/toolbox_10_2016.pdf",
        ),
        MiscLinkItem(
            text = """חומרי עזר בלימוד תנ"ך - יאיר יוסף גוגנהיים""",
            link = "https://meyda.education.gov.il/files/noar/all_files.pdf",
        ),
        MiscLinkItem(
            text = """שו"ת בקיאות ופסוקים מקבילים - מתוך ספר פרדס אליהו""",
            link = "https://meyda.education.gov.il/files/noar/pardes_eliyahu.pdf",
        ),
        MiscLinkItem(
            text = """לימוד תנ"ך - נֹעם נתיב""",
            link = "https://drive.google.com/file/d/1L64fgdOs3i7FrPgqSM8R96aMNA_2a4L8/view?usp=sharing",
        ),
        MiscLinkItem(
            text = """🕵️‍♂️מי אני? - בתנ"ך 📖 (וואטסאפ)""",
            link = "https://chat.whatsapp.com/DqS1ll73r50D7CgoM9X42z",
        ),
        MiscLinkItem(
            text = """פורום לתורה - חידות וחידודים בתנ"ך""",
            link = "https://tora-forum.co.il/threads/%D7%97%D7%99%D7%93%D7%95%D7%AA-%D7%95%D7%97%D7%99%D7%93%D7%95%D7%93%D7%99%D7%9D-%D7%91%D7%AA%D7%A0-%D7%9A-%D7%94%D7%90%D7%A9%D7%9B%D7%95%D7%9C-%D7%94%D7%99%D7%A9%D7%9F.32117/",
        ),
        MiscLinkItem(
            text = """סיפורי התנ"ך כלשונם""",
            link = "https://www.youtube.com/@tanach.stories",
        ),
    )
}
